import type { ControlPlaneCapability } from '@internal/spassu-code-contract';
import {
  Box,
  Button,
  Tooltip,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  reason: {
    color: theme.palette.text.secondary,
  },
}));

/** Blocked actions remain visible, disabled and accessible (ADR-006). */
export function CapabilityButton(props: {
  capability: ControlPlaneCapability;
  label: string;
  busy: boolean;
  variant?: 'contained' | 'outlined';
  color?: 'primary' | 'secondary';
  onClick(): void;
}) {
  const classes = useStyles();
  const reasonId = `capability-reason-${props.label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')}`;
  const disabled = !props.capability.allowed || props.busy;
  const button = (
    <Button
      variant={props.variant ?? 'outlined'}
      color={props.color ?? 'primary'}
      onClick={props.onClick}
      disabled={disabled}
      aria-describedby={props.capability.allowed ? undefined : reasonId}
    >
      {props.label}
    </Button>
  );
  return (
    <Box className={classes.row}>
      {props.capability.allowed ? (
        button
      ) : (
        <Tooltip title={props.capability.reason ?? 'Ação não permitida.'}>
          <span>{button}</span>
        </Tooltip>
      )}
      {props.capability.allowed ? null : (
        <Typography
          id={reasonId}
          variant="caption"
          className={classes.reason}
          data-testid={`${reasonId}-text`}
        >
          {props.capability.reason ?? 'Ação não permitida.'}
        </Typography>
      )}
    </Box>
  );
}
